import React from "react";

import PostList from "./PostList";

const App = () => {
  return (
    <div className="ui container">
      <PostList />
    </div>
  );
};

export default App;
